import React from "react";

import { Text } from "@performyard/py-components";

import { FormPreviewCard } from "./FormPreviewCard";
import { GeneratedContentContainer } from "./GeneratedContentContainer";

import type { FormSuggestionState } from "../types";

type FormSuggestionsContainerProps = {
	suggestionStates: FormSuggestionState[];
	onCreateForm: (suggestionId: string) => void;
	onDeleteForm: (suggestionId: string) => void;
	creatingFormIds?: Set<string>;
};

export const FormSuggestionsContainer: React.FC<FormSuggestionsContainerProps> = ({
	suggestionStates,
	onCreateForm,
	onDeleteForm,
	creatingFormIds,
}) => {
	const visibleSuggestions = suggestionStates.filter((fs) => fs.status !== "deleted");
	const allDeleted = visibleSuggestions.length === 0;

	return (
		<GeneratedContentContainer title="Suggested Form">
			{allDeleted ? (
				<Text size="paragraph-3" color="neutral-7">
					All suggested forms have been removed.
				</Text>
			) : (
				visibleSuggestions.map((fs) => (
					<FormPreviewCard
						key={fs.suggestion.id}
						suggestionState={fs}
						onCreateForm={() => onCreateForm(fs.suggestion.id)}
						onDeleteForm={() => onDeleteForm(fs.suggestion.id)}
						isCreating={creatingFormIds?.has(fs.suggestion.id)}
					/>
				))
			)}
		</GeneratedContentContainer>
	);
};

export default FormSuggestionsContainer;
